import type { DynamoDbAiComponents } from "@p0security/integrations-dynamodb-ai-shared/components";
import {
  type FrontendInstaller,
  otherInstalledIntegration,
} from "@p0security/integrations-installer";

type DynamoDbAiInstaller = FrontendInstaller<typeof DynamoDbAiComponents>;

export const dynamoDbAiInstaller: DynamoDbAiInstaller = {
  components: {
    "iam-write": {
      // Nothing to apply in AWS: the item uses the account's AWS IAM
      // management and AWS OIDC federation installs.
      instructions: (_context, accountId) => ({
        help: (
          <>
            This lets agents request read or write access to DynamoDB tables in
            AWS account {accountId}. Install AWS IAM management and AWS OIDC
            federation for the account first. Agents can list tables only in
            Regions where AWS Resource Explorer has an index.
          </>
        ),
      }),
      optionProvider: otherInstalledIntegration({
        integration: "aws",
        component: "iam-write",
      }),
    },
  },
};
